const visitLimitOptions = [
  { value: 15000, label: '0 - 15,000' },
  { value: 30000, label: '15,000 - 30,000' },
  { value: 50000, label: '30,000 - 50,000' },
  { value: 70000, label: '50,000 - 70,000' },
  { value: 100000, label: '70,000 - 100,000' },
  { value: 200000, label: '100,000 - 200,000' },
  { value: 500000, label: '200,000 - 500,000' },
  { value: 1000000, label: '500,000 - 1,000,000' },
  { value: 2000000, label: '1,000,000 - 2,000,000' },
  { value: 4000000, label: '2,000,000 - 4,000,000' },
  { value: -1, label: 'Unlimited' },
];

module.exports = {
  visitLimitOptions,
};
